module.exports = __webpack_public_path__ + "static/media/newzealand.c26ed587.webp";